import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
} from '@/components/common/skeleton';

const THREAD_COUNT = 6;

export const ThreadModerationListSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {Array.from({ length: THREAD_COUNT }).map((_, i) => (
      <SkeletonCard key={i} style={styles.cardSpacing}>
        <SkeletonBone width="80%" height={18} />
        <View style={styles.metaRow}>
          <SkeletonBone width="30%" height={12} />
          <SkeletonBone width="20%" height={12} />
          <SkeletonBone width={60} height={18} borderRadius={10} />
        </View>
        <SkeletonBone width="90%" height={14} />
      </SkeletonCard>
    ))}
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 8,
  },
  cardSpacing: {
    marginBottom: 12,
  },
  metaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
});
